import { allHostList } from '@/config/utils'

const configObj = {
  // 前端日志管理过滤域名
  interceptDomain: allHostList().originList,
  // 前端日志过滤请求地址
  // UID 查询、核身短码、挑战上下文与视频都不得进入浏览器请求采集日志。
  filterHttpUrl: ['bl-log/web', '/lt-web/xs/user/getPhoneUid', 'identity-verifications', 'userAuth/faceRecognition'],
  // 前端日志管理接口
  bllogAddUrl: 'https://bllog.yijiesudai.com/bl-log/web/log/add',
  // bllogAddUrl: '/bl-log/web/log/add',
  // 视频录制接口
  videoRecordUrl: 'https://bllog.yijiesudai.com/bl-log/web/record/report',
  // 视频录制页面场景列表接口
  videoRecordPageSceneListUrl: 'https://bllog.yijiesudai.com/bl-log/web/record/queryVideoPageSceneList',
  // 钉钉机器人接口
  dingtalkRobotSendUrl: 'https://bllog.yijiesudai.com/bl-log/web/dingtalk/robot/send',
  // 用户返回returnData数据上传接口
  userReturnDataUrl: 'https://bllog.yijiesudai.com/bl-log/web/app/send/returnData',
  // vconsole过滤域名
  vConsoleDomain: '',
  // sdk过滤域名
  sdkDomain: ''
}

export default configObj
